<template>
  <!--存取款组件-->
  <div>
    <!--黑名单存款弹窗-->
    <BlackListPop
      v-if="isBlackList"
      :source="source"
      :is-black-list="isBlackList"
      :page-type="pageType"
      @changeBlack="changeBlack"
    />
    <!--添加银行卡弹窗-->
    <noBankPop
      v-if="isBankPop"
      :source="source"
      :is-bank-pop="isBankPop"
      :page-type="pageType"
      @changeBank="changeBank"
    />
    <!--人脸识别弹窗-->
    <FacePop
      v-if="isFacePop"
      :source="source"
      :is-face-pop="isFacePop"
      :face-detection="faceDetection"
      :face-channel="faceChannel"
      :page-type="pageType"
      @changeFacePop="changeFacePop"
    />
    <!--首次存款弹窗-->
    <FirstDeposit
      v-if="isFirstDepositPop"
      :source="source"
      :is-first-deposit-pop="isFirstDepositPop"
      :page-type="pageType"
      @changeFirstDepositPop="changeFirstDepositPop"
    />
    <!--首次提现弹窗-->
    <FirstWithdrawal
      v-if="isFirstWithdrawalPop"
      :source="source"
      :is-first-withdrawal-pop="isFirstWithdrawalPop"
      :page-type="pageType"
      @changeFirstWithdrawal="changeFirstWithdrawal"
    />
    <!--资料审核提现弹窗-->
    <UnreviewedBank
      v-if="isUnreviewedBank"
      :source="source"
      :is-unreviewed-bank="isUnreviewedBank"
      :err-message="errMessage"
      :page-type="pageType"
      @changeUnreviewedBank="changeUnreviewedBank"
    />
  </div>
</template>

<script>
import FacePop from '@/view/module/FacePop.vue'
import BlackListPop from '@/view/module/BlackListPop.vue'
import noBankPop from '@/view/module/noBankPop.vue'
import FirstDeposit from '@/view/module/FirstDeposit.vue'
import FirstWithdrawal from '@/view/module/FirstWithdrawal.vue'
import UnreviewedBank from '@/view/module/UnreviewedBank.vue'
import utils from '@/utils/tradeDataUtil'
import api from '@/plugins/api'
import { mapState } from 'vuex'

export default {
  components: {
    FacePop,
    BlackListPop,
    noBankPop,
    FirstDeposit,
    FirstWithdrawal,
    UnreviewedBank
  },
  props: ['source', 'moneyStatus', 'buttonData'],
  computed: {
    ...mapState(['pageType', 'version', 'sourceType'])
  },
  data() {
    const u = navigator.userAgent
    return {
      isBankPop: false,
      isBlackList: false,
      isFacePop: false,
      isFirstDepositPop: false,
      isFirstWithdrawalPop: false,
      isUnreviewedBank: false,
      errMessage: '',
      faceDetection: '',
      faceChannel: '', // 人脸版本
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      appObj: ''
    }
  },
  mounted() {
    if (this.pageType == 'app' || this.sourceType == 'old') {
      this.getAPPInfo()
      window.getInfoCallback = (...arg) => {
        this.appInfoCallback(...arg)
      }
    } else {
      if (this.moneyStatus == 'recharge') this.buttonDeposit()
      if (this.moneyStatus == 'withdrawal') this.buttonWithdrawal()
    }
  },
  methods: {
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    changeBank(data) {
      this.$emit('moneyStatue', data)
      this.isBankPop = data
    },
    changeFacePop(data) {
      this.$emit('moneyStatue', data)
      this.isFacePop = data
    },
    changeBlack(data) {
      this.$emit('moneyStatue', data)
      this.isBlackList = data
    },
    changeFirstDepositPop(data) {
      this.$emit('moneyStatue', data)
      this.isFirstDepositPop = data
    },
    changeFirstWithdrawal(data) {
      this.$emit('moneyStatue', data)
      this.isFirstWithdrawalPop = data
    },
    changeUnreviewedBank(data) {
      this.$emit('moneyStatue', data)
      this.isUnreviewedBank = data
    },
    getAPPInfo() {
      // 获取app信息
      let mapJson
      try {
        if (this.isIOS) {
          if (typeof window.getInfo != 'undefined') {
            mapJson = window.getInfo()
          } else {
            window.webkit.messageHandlers.getInfo.postMessage(null)
          }
        } else {
          mapJson = window.uiObject.getInfo()
        }
      } catch (err) {
        mapJson = ''
      }
      if (mapJson != null && mapJson != '' && mapJson != 'null') {
        this.appObj = eval('(' + mapJson + ')')
        this.getAppChannel(this.appObj)
      }
    },
    appInfoCallback(info) {
      if (typeof info != 'undefined') {
        const appInfo = JSON.stringify(info)
        this.appObj = JSON.parse(appInfo)
        this.getAppChannel(this.appObj)
      }
    },
    getAppChannel(appObj) {
      let channel, device, version
      if (this.isIOS) {
        channel = appObj.channel ? appObj.channel : ''
        device = 'IOS'
        version = this.version
      } else {
        channel = appObj.flavor ? appObj.flavor : ''
        device = 'Android'
        version = appObj.appVerCode ? appObj.appVerCode : ''
      }
      const data = {
        channel: channel,
        device: device,
        version: version,
        businessType: '72'
      }
      api.getFaceChannel(this.$qs.stringify(data)).then((res) => {
        if (res.data.code == 200) {
          if (utils.isNotEmpty(res.data.data.faceChannel)) { this.faceChannel = res.data.data.faceChannel } else this.faceChannel = ''
          if (this.moneyStatus == 'recharge') this.buttonDeposit()
          if (this.moneyStatus == 'withdrawal') this.buttonWithdrawal()
        }
      })
    },
    buttonDeposit() {
      this.$bus.$emit('loading', false)
      if (this.buttonData.faceDetection) {
        this.faceDetection = this.buttonData.faceDetection
        const depositBankStatus = this.buttonData.depositBankStatus
        const certificateStatus = this.buttonData.certificateStatus.status
        if (
          this.faceDetection.isBlacklist ||
          this.buttonData.paySwitchSeqTagCode == 'A9'
        ) {
          this.toggleFixed()
          this.$bus.$emit('loading', true)
          this.isBlackList = !this.isBlackList
        } else {
          if (!depositBankStatus) {
            this.toggleFixed()
            this.$bus.$emit('loading', true)
            this.isBankPop = !this.isBankPop
          } else {
            if (this.faceDetection.isFaceValidate) {
              this.$bus.$emit('loading', true)
              if (utils.isNotEmpty(this.faceChannel)) {
                this.toggleFixed()
                this.isFacePop = !this.isFacePop
              }
            } else {
              if (certificateStatus != 'APPROVAL') {
                this.toggleFixed()
                this.$bus.$emit('loading', true)
                this.isFirstDepositPop = !this.isFirstDepositPop
              }
            }
          }
        }
      }
    },
    buttonWithdrawal() {
      this.$bus.$emit('loading', false)
      if (this.buttonData.faceDetection) {
        this.faceDetection = this.buttonData.faceDetection
        const certificateStatus = this.buttonData.certificateStatus.status
        if (this.faceDetection.isBlacklist) {
          this.toggleFixed()
          this.$bus.$emit('loading', true)
          this.isBlackList = !this.isBlackList
        } else {
          if (certificateStatus == 'PRE_APPROVAL') {
            this.toggleFixed()
            this.$bus.$emit('loading', true)
            this.errMessage = '您的取款资料正在审核中，请耐心等待'
            this.isUnreviewedBank = !this.isUnreviewedBank
          } else if (certificateStatus == 'CANCEL') {
            this.toggleFixed()
            this.$bus.$emit('loading', true)
            this.errMessage = this.buttonData.certificateStatus.reason
            this.isUnreviewedBank = !this.isUnreviewedBank
          } else if (certificateStatus == 'EMPTY') {
            this.toggleFixed()
            this.$bus.$emit('loading', true)
            this.isFirstWithdrawalPop = !this.isFirstWithdrawalPop
          } else if (certificateStatus == 'APPROVAL') {
            if (this.faceDetection.isFaceValidate) {
              this.$bus.$emit('loading', true)
              if (utils.isNotEmpty(this.faceChannel)) {
                this.toggleFixed()
                this.isFacePop = !this.isFacePop
              }
            }
          }
        }
      }
    }
  }
}
</script>
